<template>
  <section>
    <h5 class="mb-4">Account Verification</h5>
    <p>Please enter the 4-digit PIN to proceed</p>
    <b-row>
      <b-col md="6">
        <b-form @submit.prevent="proceedVerifyPin" autocomplete="off">
          <b-form-group
            :state="isValid('pin')"
            :invalid-feedback="errorMessage('pin')">
            <input
              id="pin"
              ref="pin"
              v-model="pin"
              type="text"
              :maxlength="pinLength"
              inputmode="numeric"
              pattern="[0-9]*"
            />
          </b-form-group>
          <b-form-group>
            <b-button variant="primary"
              type="submit"
              class="border-0 px-5"
              pill
              :style="{
                'background-color': webDesign && webDesign.design ? webDesign.design.main_color : null,
                'color': webDesign && webDesign.design ? webDesign.design.button_text_color : null
              }"
              :disabled="isInvalidPinLength || loading">
              Proceed
            </b-button>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
  name: 'ChangeMobileAccountVerification',
  props: ['webDesign', 'customer'],
  data() {
    return {
      pin: "",
      pinLength: 4
    }
  },
  computed: {
    ...mapState('auth', {
      token: state => state.token
    }),
    ...mapState('merchant', {
      customerPortalToken: state => state.customerPortalToken
    }),
    ...mapState('customer', {
      errors: state => state.errors,
      loading: state => state.loading
    }),
    isInvalidPinLength() {
      return this.pin.length < this.pinLength;
    }
  },
  created() {
    this.$nextTick(() => {
      this.$refs.pin.focus();
    });
  },
  beforeDestroy() {
    this.setErrors(null);
  },
  methods: {
    ...mapActions({
      validateUserPin: 'customer/validateUserPin'
    }),
    ...mapMutations({
      setErrors: 'customer/SET_ERRORS'
    }),
    async proceedVerifyPin() {
      const request = {
        header: {
          "Authorization": this.token,
          "X-Merchant-Token": this.customerPortalToken
        },
        payload: {
          pin: this.pin,
          customer_uuid: this.customer.uuid
        }
      };

      await this.validateUserPin(request);

      if (!this.errors || Object.keys(this.errors).length === 0) this.$emit('change-component', 'NewMobileNumber');
    },
    isValid(field) {
      if (this.errors == null) {
        return false;
      }
      return this.errors[field] ? false : true;
    },
    errorMessage(field) {
      if (this.errors == null) {
        return "";
      }
      return this.errors[field];
    }
  },
  watch: {
    pin(pin) {
      this.pin = pin.replace(/\D/g, "");
    },
  }
}
</script>

<style lang="scss">
@import '~@/assets/styles/views/profile/_change.mobile';
</style>
